var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportAnalyticsLogisticsV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65723 9.98076H2.74414M8.65723 9.98076H11.5886M8.65723 9.98076C8.65723 9.98076 8.65723 8.14046 8.65723 6.96127V3.94178C8.65723 3.63917 8.3138 3.13497 8.3138 3.13497C8.3138 3.13497 7.79566 2.80078 7.48468 2.80078H2.74414",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.588 10.5508C11.588 11.1809 11.0133 11.6918 10.3044 11.6918C9.59545 11.6918 9.02075 11.1809 9.02075 10.5508",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88415 10.5508C5.88415 11.1809 5.30945 11.6918 4.60052 11.6918C3.89159 11.6918 3.31689 11.1809 3.31689 10.5508",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.27148 4.95703H2.98299",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 6.91602L2.98196 6.91602",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4816 9.97932H12.6939C12.8546 9.97932 13.0088 9.91921 13.1225 9.81222C13.2362 9.70524 13.3 9.56013 13.3 9.40882V7.89685C13.2998 7.76739 13.2528 7.64185 13.1667 7.54086L12.531 6.79297L11.1203 5.46451C11.0636 5.39769 10.9916 5.34372 10.9098 5.30659C10.828 5.26946 10.7383 5.25012 10.6475 5.25C10.5566 5.24988 8.75 5.25 8.75 5.25",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalyticsLogisticsV2);
export default __webpack_public_path__ + "static/media/reportAnalyticsLogisticsV2.337bf3188b02f642a5d2a3cb72084e6c.svg";
export { ForwardRef as ReactComponent };